import * as types from './mutation-types'
/* eslint-disable */

export const loadNotes = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/atelier/note/' + id).then((response) => {
            commit(types.LOAD_NOTES, response.data.notes) 
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createNote = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/atelier/note', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateNote = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/atelier/note/' + data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const deleteNote = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/atelier/note/' +id ).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
